<div class="d-flex align-items-center gap-3 mb-3">
  <div class="d-flex align-items-center gap-2">
    <h6 class="page-title mb-0" i18n>Discounts</h6>
    <app-page-help [articleId]="'t47j26ldtu'" videoId="-"></app-page-help>
  </div>
  <div class="flex-fill"></div>
  <div class="btn-group dropdown" role="group" dropdown [isDisabled]="1 | isReadonlyRole">
    <button dropdownToggle type="button" class="btn btn-secondary-warning dropdown-toggle">
      <span class="cs-icon cs-icon-bolt"></span> <ng-container i18n>Actions</ng-container>
    </button>
    <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
      <li [matTooltip]="getDownloadTooltip(table.dataSource?.data?.length)" matTooltipPosition="left" class="btn-group">
        <button (click)="onExport()" [disabled]="!table.dataSource?.data?.length" type="button">
          <i class="cs-icon cs-icon-cloud-download"></i>
          <ng-container i18n>Download</ng-container>
        </button>
      </li>
      <li>
        <button
          (click)="onDeleteSelected()"
          type="button"
          matTooltip="Delete the selected discount(s)."
          matTooltipPosition="left"
          i18n-matTooltip
          [disabled]="!table.isAnySelected()"
        >
          <i class="cs-icon cs-icon-trash"></i><ng-container i18n>Delete</ng-container>
        </button>
      </li>
    </ul>
  </div>
  <div class="btn-group" dropdown [isDisabled]="1 | isReadonlyRole">
    <button type="button" class="btn btn-secondary-info dropdown-toggle" dropdownToggle>
      <span class="far fa-plus"></span> <ng-container i18n>Add Discount</ng-container>
    </button>
    <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
      <li class="menu-item-success">
        <button
          type="button"
          (click)="table?.onAddDiscountCode()"
          matTooltip="Incentivize guests to book longer stays at your rental property by offering a discount based on the length of their reservation."
          matTooltipPosition="left"
          i18n-matTooltip
        >
          <i class="cs-icon cs-icon-percent fa-fw text-sm"></i>
          <ng-container i18n>Discount Code</ng-container>
        </button>
      </li>
      <li class="menu-item-indigo">
        <button
          type="button"
          (click)="table?.onAddLosDiscount()"
          matTooltip="Add Codes to offer Discounts for your Webready bookings."
          matTooltipPosition="left"
          i18n-matTooltip
        >
          <i class="cs-icon cs-icon-home-percent fa-fw"></i>
          <ng-container i18n>LOS Discount</ng-container>
        </button>
      </li>
    </ul>
  </div>
</div>
<div class="container-box">
  <app-discounts-table #table></app-discounts-table>
</div>
